<div class="modal_dialog">
    <div class="modal_header">
      <h2>{{ 'ProductList' | translate }}</h2>
      <button class="btnn close_icon" [mat-dialog-close]> <mat-icon>close</mat-icon> </button>
    </div>
    <div class="modal_body">
        <form>
            <div class="gap_m">
                <div class="usr_profile w_100">
                    <p>{{ 'Product Image' | translate }}</p>
                    <div class="position_relative usr_profile_img_wrp">
                      <figure class="usr_profile_img">
                        <img
                          [src]="
                            assetsConst.placeHolder
                          "
                          alt="user" />
                      </figure>
                      <figure class="camera_icon hide_camera">
                        <img src="{{ assetsConst.cameraIcon }}" alt="" />
                        <input
                          type="file"
                          class="form_control"
                          />
                      </figure>
                    </div>
                  </div>

              <div class="form_group w_50">
                <mat-label class="required">{{ 'Product Name' | translate }} </mat-label>
      
                <mat-form-field appearance="fill">
                  <input
                    matInput
                    placeholder="{{ 'Enter Product Name' | translate }}"
                    class="form_control"
                    type="text"
                    formControlName="name" />
                </mat-form-field>
              </div>
              <div class="form_group w_50">
                  <mat-label class="required">{{ 'Product Category' | translate }} </mat-label>
        
                  <mat-form-field appearance="fill">
                    <mat-select
                    placeholder="{{ 'Select' | translate }}"
                    class="form_control">
                    <mat-option value="1">Toy Car</mat-option>
                    <mat-option value="2">Sports</mat-option>
                    <mat-option value="3">Sports</mat-option>
                  </mat-select>
                  </mat-form-field>
                </div>
      
                <div class="form_group w_50">
                  <mat-label class="required">{{ 'Rack' | translate }} </mat-label>
        
                  <mat-form-field appearance="fill">
                    <mat-select
                    placeholder="{{ 'Select' | translate }}"
                    class="form_control">
                    <mat-option value="1">456</mat-option>
                    <mat-option value="2">654</mat-option>
                    <mat-option value="3">123</mat-option>
                  </mat-select>
                  </mat-form-field>
                </div>
      
            </div>
            <div class="submit_btn">
              <button class="btnn btn_primary" type="button">
                {{ 'Save' | translate }}
              </button>
            </div>
          </form>
    </div>
  </div>
  